import { render, staticRenderFns } from "./DigitalFilesList.vue?vue&type=template&id=53ff65c0&scoped=true&"
import script from "./DigitalFilesList.vue?vue&type=script&lang=js&"
export * from "./DigitalFilesList.vue?vue&type=script&lang=js&"
import style0 from "./DigitalFilesList.vue?vue&type=style&index=0&id=53ff65c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff65c0",
  null
  
)

export default component.exports